let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Otqf")).then(() => parcelRequire('4Muh9'));